/**
 * @file WebSocket Response Metrics Handler
 * @description Handles the recording of OpenTelemetry metrics for WebSocket responses, including duration, status, and response size.
 */

import { wsRequestDuration, wsResponseSize, wsStatusCounter } from '../metrics';
import { buildWsResponseMetricAttributes } from './wsMetricAttributes';
import { STATUSES } from '../constants';

/**
 * Records OpenTelemetry metrics for a WebSocket response.
 *
 * @param {number} duration - The duration of the WebSocket request in milliseconds.
 * @param {string} method - The WebSocket method name.
 * @param {string} status - The status of the WebSocket response.
 * @param {number} dataSizeInBytes - The size of the data received in the WebSocket response in bytes.
 */
export const otlHandleWsResponseMetrics = (duration, method, status, dataSizeInBytes) => {
    const attributes = buildWsResponseMetricAttributes(method, status);

    wsRequestDuration.record(duration, attributes);
    wsStatusCounter.add(1, attributes);
    if (status === STATUSES.OK && dataSizeInBytes) {
        wsResponseSize.record(dataSizeInBytes, attributes);
    }
};
